// import React, { useState, useEffect, useCallback } from 'react'
// import { HistoryContainerOne, Texts, InnerContainer, HistoryContainerTwo, Details, Label, HeaderText, Headers, Paragraph, HeaderTextContainer, Border, CircleContainer, LabelText, CircleInner } from './Style';
// import DateTimePicker from 'src/components/App/DatePicker';
// import theme, { palette } from 'src/config/theme';
// import { alpha } from '@mui/material';
// import InputSelect from 'src/components/shared/Form/Select';
// import { Box } from '@mui/material';
// import useAppointmentDetails from '../../UseAppointmentDetails';
// import { useDispatch } from 'react-redux';
// import { getPatientHistoryByPatientIdRequest } from 'src/modules/app/store/appActions';
// import storage from "src/utils/storageUtils";

// function History() {
//   const { PatientId, user } = useAppointmentDetails();
//   const dispatch = useDispatch();
//   const [patients, setPatients] = useState([]);

//   const All = [
//     { label: 'All Events', value: 'all event' },
//     { label: 'Appointments', value: 'appointments' },
//     { label: 'Notes', value: 'notes' },
//     { label: 'Prescription', value: 'prescription' },
//   ]
//   const [select, setSelect] = useState(null);
//   const [selectValue, setSelectValue] = useState('');
//   const handleChange = (value) => {
//     setSelectValue(value);
//     console.log("Selected Value:", value);
//   };
//   // const fetchPatientHistory = useCallback(() => {

//   //   const fetchData = async () => {
//   //     const response = await new Promise((resolve, reject) =>
//   //       dispatch(getPatientHistoryByPatientIdRequest(PatientId, resolve, reject))
//   //     );
//   //     if (response) {
//   //       setPatients(response);
//   //       console.log("history response", response)
//   //     }
//   //   };
//   //   fetchData();
//   // }, [dispatch]);

//   // useEffect(() => {
//   //   fetchPatientHistory();
//   // }, [fetchPatientHistory]);

//   return (
//     <>

//       <HistoryContainerOne>
//         <Texts>
//           Filter Activities By:
//         </Texts>
//         <InnerContainer>
//           <Box sx={{ width: '320px' }}>
//             <DateTimePicker
//               // label="Select Dategroup"
//               value={select}
//               onChange={setSelect}
//               type="date"

//               sx={{
//                 width: '320px',
//                 height: "52px",
//                 borderRadius: '12px',
//                 // padding: '10px auto',
//                 backgroundColor: theme.palette.gery.white,
//                 border: `1px solid ${alpha(theme.palette.gery.black, 0.14)}`,
//                 boxShadow: theme.shadows[1],
//               }}
//             />
//           </Box>
//           <InputSelect
//             value={selectValue}
//             options={All}
//             onChange={handleChange}
//             variant="outlined"
//             placeholder="Choose"
//             sx={{
//               width: '250px',
//               boxShadow: theme.shadows[1],
//               '& .MuiOutlinedInput-root': {
//                 height: '52px',
//                 display: 'flex',
//                 alignItems: 'center',
//                 // border: `1px solid ${alpha(theme.palette.gery.black, 0.14)}`,
//                 borderRadius: '12px',
//               },
//             }}
//           />
//         </InnerContainer>

//       </HistoryContainerOne>
//       <HistoryContainerTwo>
//         <Details>
//           <LabelText>

//             <Label>
//               12th Oct, 10:00am
//             </Label>
//           </LabelText>
//           <HeaderTextContainer>
//             <Border>

//             </Border>
//             <CircleContainer>
//               <CircleInner></CircleInner>
//             </CircleContainer>
//             <HeaderText>
//               <Headers>
//                 Appointment Added
//               </Headers>
//               <Paragraph>
//                 The patients that helps Practices serve more people with the
//                 same resources they have now, or less
//               </Paragraph>

//             </HeaderText>
//           </HeaderTextContainer>

//         </Details>
//         <Details>
//           <LabelText>

//             <Label>
//               12th Oct, 10:00am
//             </Label>
//           </LabelText>
//           <HeaderTextContainer sx={{ height: '180px' }}>
//             <Border>

//             </Border>
//             <CircleContainer>
//               <CircleInner></CircleInner>
//             </CircleContainer>
//             <HeaderText>
//               <Headers>
//                 Prescription Added
//               </Headers>
//               <Paragraph sx={{}}>
//                 Prescription:
//               </Paragraph>
//               <Paragraph>
//                 LapidCrim 50mg (1-1-0) <br />
//                 Sinthol 50mg (1-0-1) <br />
//                 Dolo 350 (1-1-1)
//               </Paragraph>

//             </HeaderText>
//           </HeaderTextContainer>

//         </Details>
//         <Details>
//           <LabelText>

//             <Label>
//               12th Oct, 10:00am
//             </Label>
//           </LabelText>
//           <HeaderTextContainer sx={{ height: '130px' }}>
//             <Border>

//             </Border>
//             <CircleContainer>
//               <CircleInner></CircleInner>
//             </CircleContainer>
//             <HeaderText>
//               <Headers>
//                 Notes Added
//               </Headers>
//               <Paragraph>
//                 Patient have diabetes.
//               </Paragraph>

//             </HeaderText>
//           </HeaderTextContainer>

//         </Details>
//         <Details>
//           <LabelText>

//             <Label>
//               12th Oct, 10:00am
//             </Label>
//           </LabelText>
//           <HeaderTextContainer sx={{ height: '100px' }}>
//             <Border>

//             </Border>
//             <CircleContainer>
//               <CircleInner></CircleInner>
//             </CircleContainer>
//             <HeaderText>
//               <Box sx={{ display: 'flex', gap: '10px' }}>
//                 <Headers>
//                   Payments Generated of Appointment
//                 </Headers>
//                 <Headers sx={{ color: palette.primary.main, borderBottom: `2px solid ${palette.primary.main}` }}>
//                   Download Bill
//                 </Headers>
//               </Box>

//             </HeaderText>
//           </HeaderTextContainer>

//         </Details>
//         <Details>
//           <LabelText>

//             <Label>
//               12th Oct, 10:00am
//             </Label>
//           </LabelText>
//           <HeaderTextContainer>
//             <Border>

//             </Border>
//             <CircleContainer>
//               <CircleInner></CircleInner>
//             </CircleContainer>
//             <HeaderText>
//               <Headers>
//                 New Patient Added
//               </Headers>
//               <Paragraph>
//                 The patients that helps Practices serve more people with the
//                 same resources they have now, or less              </Paragraph>

//             </HeaderText>
//           </HeaderTextContainer>

//         </Details>
//         <Details >
//           <LabelText>

//             <Label>
//               12th Oct, 10:00am
//             </Label>
//           </LabelText>
//           <HeaderTextContainer sx={{ height: '60px' }}>
//             <Border>

//             </Border>
//             <CircleContainer>
//               <CircleInner></CircleInner>
//             </CircleContainer>
//             <HeaderText>
//               <Box sx={{ display: 'flex', gap: '10px' }}>
//                 <Headers>
//                   Payments Generated of Appointment
//                 </Headers>
//                 <Headers sx={{ color: palette.primary.main, borderBottom: `2px solid ${palette.primary.main}` }}>
//                   Download Bill
//                 </Headers>
//               </Box>

//             </HeaderText>
//           </HeaderTextContainer>

//         </Details>
//       </HistoryContainerTwo>

//     </>

//   )
// }

// export default History;


import React, { useState, useEffect, useCallback } from 'react';
import {
  HistoryContainerOne,
  Texts,
  InnerContainer,
  HistoryContainerTwo,
  Details,
  Label,
  HeaderText,
  Headers,
  Paragraph,
  HeaderTextContainer,
  Border,
  CircleContainer,
  LabelText,
  CircleInner,
  HistoryWrapper
} from './Style';
import DateTimePicker from 'src/components/App/DatePicker';
import theme, { palette } from 'src/config/theme';
import { alpha } from '@mui/material';
import InputSelect from 'src/components/shared/Form/Select';
import { Box } from '@mui/material';
import useAppointmentDetails from '../../UseAppointmentDetails';
import { useDispatch } from 'react-redux';
import useResponsive from 'src/components/hooks/useResponsive';
import {
  getPatientHistoryByPatientIdRequest,
  getDownloadReportByIdRequest,
} from 'src/modules/app/store/appActions';
import storage from 'src/utils/storageUtils';
import moment from 'moment';
import dayjs from 'dayjs';

function History() {
  const { PatientId, user } = useAppointmentDetails();
  const { isMobile, isTablet, isDesktop } = useResponsive();
  const dispatch = useDispatch();
  const [patients, setPatients] = useState([]);

  const All = [
    { label: 'All Events', value: 'all event' },
    { label: 'Treatments', value: 'treatments' },
    { label: 'Notes', value: 'notes' },
    { label: 'Prescription', value: 'prescription' },
    { label: 'Reports', value: 'reports' },
    { label: 'Billing', value: 'billings' },
  ];

  const [select, setSelect] = useState(new Date());
  const [selectValue, setSelectValue] = useState('all event');

  const handleChange = (value) => {
    setSelectValue(value);
    console.log('Selected Value:', value);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await new Promise((resolve, reject) => {
          dispatch(getPatientHistoryByPatientIdRequest(PatientId, resolve, reject));
        });

        if (response) {
          setPatients(response);
        }
      } catch (error) {
        console.error('Handled error:', error);
      }
    };

    fetchData();
  }, [PatientId, dispatch]);

  const handleDownloadReport = async (reportId, contentType, reportName) => {
    try {
      const response = await new Promise((resolve, reject) => {
        dispatch(getDownloadReportByIdRequest(reportId, resolve, reject));
      });

      if (response) {
        const blob = new Blob([response], { type: contentType });
        const link = document.createElement('a');
        const url = window.URL.createObjectURL(blob);
        const fileExtension = contentType.split('/')[1];
        const fileName = `report-${reportName}.${fileExtension}`;
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } else {
        console.error('No file data received for download.');
      }
    } catch (error) {
      console.error('Error during download:', error);
    }
  };

  const isSameDate = (date1, date2) => {
    if (!date1 || !date2) return false;
    return dayjs(date1).format('YYYY-MM-DD') === dayjs(date2).format('YYYY-MM-DD');
  };

  const groupByDate = (items, selectedDate, selectedType, itemType) => {
    if (selectedType && selectedType !== 'all event' && selectedType !== itemType) {
      return {};
    }

    return items
      .filter((item) => !selectedDate || isSameDate(item.createdAt, selectedDate))
      .reduce((acc, item) => {
        const dateKey = dayjs(item.createdAt).format('DD MMM, hh:mm A');
        if (!acc[dateKey]) {
          acc[dateKey] = [];
        }
        acc[dateKey].push(item);
        return acc;
      }, {});
  };

  const groupedNotes = groupByDate(patients?.notes || [], select, selectValue, 'notes');
  const groupedPrescriptions = groupByDate(patients?.prescriptions || [], select, selectValue, 'prescription');
  // const groupedTreatments = groupByDate(patients?.treatments || [], select, selectValue, 'treatments');
  const filteredTreatments = (patients?.treatments || [])
    .filter((item) => !select || isSameDate(item.createdAt, select))
    .filter((item) => selectValue === 'all event' || selectValue === 'treatments')
    .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));

  const groupedReports = groupByDate(patients?.reports || [], select, selectValue, 'reports');
  const groupedBillings = groupByDate(patients?.billings || [], select, selectValue, 'billings');

  const renderNoHistoryMessage = () => {
    const allGroupsEmpty =
      Object.keys(groupedNotes).length === 0 &&
      Object.keys(groupedPrescriptions).length === 0 &&
      Object.keys(filteredTreatments).length === 0 &&
      Object.keys(groupedReports).length === 0 &&
      Object.keys(groupedBillings).length === 0;

    if (allGroupsEmpty) {
      return <Texts>No history available for this day</Texts>;
    }
    return null;
  };
  return (
    <>
      <HistoryContainerOne>
        <Texts>Filter Activities By:</Texts>
        <InnerContainer>
          <Box sx={{
            width: isDesktop ? '320px' : '100%'
          }}>
            <DateTimePicker
              value={select}
              onChange={(newDate) => {
                const dateOnly = dayjs(newDate).startOf('day').toDate();
                setSelect(dateOnly);
              }}
              type="date"
              sx={{
                width: '100%',
                height: '52px',
                borderRadius: '12px',
                backgroundColor: theme.palette.gery.white,
                border: `1px solid ${alpha(theme.palette.gery.black, 0.14)}`,
                boxShadow: theme.shadows[1],
              }}
            />
          </Box>
          <InputSelect

            value={selectValue}
            options={All}
            onChange={handleChange}
            variant="outlined"
            placeholder="Choose"
            showNone={false}
            sx={{
              width: isDesktop ? '250px' : '100%',
              boxShadow: theme.shadows[1],
              '& .MuiOutlinedInput-root': {
                height: '52px',
                display: 'flex',
                alignItems: 'center',
                borderRadius: '12px',
                backgroundColor: theme.palette.gery.white,
              },
            }}
          />
        </InnerContainer>
      </HistoryContainerOne>
      <HistoryWrapper>
        <HistoryContainerTwo>
          {renderNoHistoryMessage()}
          {Object.keys(groupedNotes).map((date) => (
            <div key={date}>
              <Details>
                <LabelText>
                  <Label>{date}</Label>
                </LabelText>
                <HeaderTextContainer>
                  <Border></Border>
                  <CircleContainer>
                    <CircleInner></CircleInner>
                  </CircleContainer>
                  <HeaderText>
                    <Headers>Notes Added</Headers>
                    {groupedNotes[date].map((note) => (
                      <Paragraph key={note.id}>{note.notes}</Paragraph>
                    ))}
                  </HeaderText>
                </HeaderTextContainer>
              </Details>
            </div>
          ))}

          {Object.keys(groupedPrescriptions).map((date) => (
            <div key={date}>
              <Details>
                <LabelText>
                  <Label>{date}</Label>
                </LabelText>
                <HeaderTextContainer sx={{ height: '180px' }}>
                  <Border></Border>
                  <CircleContainer>
                    <CircleInner></CircleInner>
                  </CircleContainer>
                  <HeaderText>
                    <Headers>Prescription Added</Headers>
                    {groupedPrescriptions[date].map((prescription) => (
                      <Paragraph key={prescription.id}>
                        {prescription.notes.split('\n').map((med, index) => (
                          <div key={index}>{med}</div>
                        ))}
                      </Paragraph>
                    ))}
                  </HeaderText>
                </HeaderTextContainer>
              </Details>
            </div>
          ))}
          {/* 
          {Object.keys(groupedTreatments).map((date) => {
            const treatmentsByType = groupedTreatments[date].reduce((acc, treatment) => {
              const type = treatment.treatmentType;
              if (!acc[type]) acc[type] = [];
              acc[type].push(treatment);
              return acc;
            }, {});

            return (
              <div key={date}>
                <Details>
                  <LabelText>
                    <Label>{date}</Label>
                  </LabelText>
                  {Object.keys(treatmentsByType).map((type) => (
                    <HeaderTextContainer key={type} sx={{ minHeight: '160px' }}>
                      <Border />
                      <CircleContainer>
                        <CircleInner />
                      </CircleContainer>
                      <HeaderText>
                        <Headers>
                          Treatment Added: {type.charAt(0).toUpperCase() + type.slice(1)}
                        </Headers>
                        {treatmentsByType[type].map((treatment) => (
                          <Paragraph key={treatment.id}>
                            <div>Treatment Name: {treatment.name}</div>
                            <div>Total:{treatment.total}</div>
                            <div>Remaining: {treatment.remaining}</div>
                            {treatment.days && treatment.days.length > 0 && (
                              <div>Days: {treatment.days.join(', ')}</div>
                            )}
                            {treatment.dateTimes && treatment.dateTimes.length > 0 && (
                              <>
                                {treatment.dateTimes.map((dt, i) => (
                                  <div key={i}>
                                    {moment(dt.date).format('DD MMM YYYY')} at{' '}
                                    {moment(dt.time).format('hh:mm A')}
                                  </div>
                                ))}
                              </>
                            )}
                          </Paragraph>
                        ))}
                      </HeaderText>
                    </HeaderTextContainer>
                  ))}
                </Details>
              </div>
            );
          })} */}

          {filteredTreatments.map((treatment) => (
            <Details key={treatment.id}>
              <LabelText>
                <Label>{dayjs(treatment.createdAt).format('DD MMM, hh:mm A')}</Label>
              </LabelText>
              <HeaderTextContainer sx={{ minHeight: '160px' }}>
                <Border />
                <CircleContainer>
                  <CircleInner />
                </CircleContainer>
                <HeaderText>
                  <Headers>
                    Treatment Added: {treatment.treatmentType?.charAt(0).toUpperCase() + treatment.treatmentType?.slice(1)}
                  </Headers>
                  <Paragraph>
                    <div>Treatment Name: {treatment.name}</div>
                    <div>Total: {treatment.total}</div>
                    <div>Remaining: {treatment.remaining}</div>
                    {treatment.days?.length > 0 && (
                      <div>Days: {treatment.days.join(', ')}</div>
                    )}
                    {treatment.dateTimes?.length > 0 && treatment.dateTimes.map((dt, i) => (
                      <div key={i}>
                        {moment(dt.date).format('DD MMM YYYY')} at {moment(dt.time).format('hh:mm A')}
                      </div>
                    ))}
                  </Paragraph>
                </HeaderText>
              </HeaderTextContainer>
            </Details>
          ))}

          {Object.keys(groupedReports).map((date) => (
            <div key={date}>
              <Details>
                <LabelText>
                  <Label>{date}</Label>
                </LabelText>
                <HeaderTextContainer sx={{ height: '80px' }}>
                  <Border></Border>
                  <CircleContainer>
                    <CircleInner></CircleInner>
                  </CircleContainer>
                  <HeaderText>
                    <Box sx={{
                      display: 'flex',
                      gap: '10px',
                      alignItems: isMobile || isTablet ? 'flex-start' : 'center',
                      flexDirection: isMobile || isTablet ? 'column' : 'row'
                    }}>
                      <Headers>Reports Uploaded</Headers>
                      {groupedReports[date].map((report) => (
                        <Headers
                          key={report.id}
                          sx={{
                            color: palette.primary.main,
                            borderBottom: `2px solid ${palette.primary.main}`,
                            cursor: 'pointer',
                          }}
                          onClick={() => {
                            handleDownloadReport(
                              report.id,
                              report.contentType,
                              report.typesOfReports || 'report',
                            );
                          }}
                        >
                          {report.typesOfReports || 'Download Report'}
                        </Headers>
                      ))}
                    </Box>
                  </HeaderText>
                </HeaderTextContainer>
              </Details>
            </div>
          ))}

          {Object.keys(groupedBillings).map((date) => (
            <div key={date}>
              <Details>
                <LabelText>
                  <Label>{date}</Label>
                </LabelText>
                <HeaderTextContainer sx={{ minHeight: '80px' }}>
                  <Border></Border>
                  <CircleContainer>
                    <CircleInner></CircleInner>
                  </CircleContainer>
                  <HeaderText>
                    <Headers>Billing Added</Headers>
                    {groupedBillings[date].map((billing) => (
                      <Paragraph key={billing.id}>
                        <div>Payment For: {billing.paymentFor}</div>
                        <div>Amount: {billing.amount > 0 ? `₹${billing.amount}` : `-₹${Math.abs(billing.amount)}`} ({billing.type})</div>
                        <div>Method: {billing.method}</div>
                      </Paragraph>
                    ))}
                  </HeaderText>
                </HeaderTextContainer>
              </Details>
            </div>
          ))}
        </HistoryContainerTwo>
      </HistoryWrapper>
    </>
  );
}

export default History;



